import { RequestError } from '@app/services/errors/RequestError';

export const request = (path: string, externalUrl?: string) => {
	const url = externalUrl ? `${externalUrl}/${path}` : `/${path}`;
	const result = {
		status: -1,
		text: '',
		ok: false,
	};

	return fetch(url, {
		method: 'GET',
		credentials: 'same-origin',
		mode: 'cors',
	})
		.then((response: Response) => {
			result.status = response.status;
			result.ok = response.ok;

			return response.json();
		})
		.then((data) => {
			if (!result.ok) throw new RequestError(result.status, data);

			return data;
		});
};

export const dataRequest = <T>(values: URLSearchParams, path: string, externalUrl?: string): Promise<T> => {
	const url = externalUrl ? `${externalUrl}/${path}` : `/${path}`;
	const result = {
		status: -1,
		text: '',
		ok: false,
	};

	return fetch(url, {
		method: 'POST',
		headers: {
			'Content-type': 'application/x-www-form-urlencoded',
		},
		body: values,
	})
		.then((response: Response) => {
			result.status = response.status;
			result.ok = response.ok;

			return response.json();
		})
		.then((data) => {
			if (!result.ok) throw new RequestError(result.status, data);

			return data;
		});
};
